<div class="d-flex overflow-auto border rounded shadow-sm h-100 w-100">
  <div class="d-grid flex-grow-1" style="grid-template-columns: repeat(7, minmax(0, 1fr)); grid-template-rows: auto repeat(6, minmax(0, 1fr))">
    <!--Days of the week-->
    <div class="d-grid position-sticky bg-white" style="top: 0; grid-template-columns: subgrid; grid-column: 1/-1">
      <ng-container *ngFor="let day of firstWeek">
        <div class="border-bottom w-100 calendar-month__week-header">
          <div class="text-center p-2">{{ day | employeeDate: 'EEEE' | async | titlecase }}</div>
        </div>
      </ng-container>
    </div>
    <!--Weeks-->
    <div class="d-grid flex-grow-1" style="grid-template-columns: subgrid; grid-template-rows: subgrid; grid-column: 1/-1; grid-row: 2/-1">
      <ng-container *ngFor="let day of dates">
        <!-- prettier-ignore -->
        <div 
            [class.cal--weekend]="(day.date.getDay() == 6 || day.date.getDay() == 0) && !settings?.disableWeekendsGrey"
            [class.cal--in-the-past]="day.date.getTime() < yesterday.getTime() && !settings?.disablePastDaysGrey"
            [class.cal--today]="DateUtil.sameDay(day.date, today) && !settings?.disableHighlightToday"
            
            [class.cal--selectable]="!settings?.disableDaySelect"
            [class.cal--selected]="day.selected"

            class="d-flex flex-column calendar-month__day"
            (mouseenter)="mouseEnterOnDate($event, day)">
          <div class="d-flex justify-content-end w-100 pe-3 pt-2">
            <span class="fs-4 calendar-today-number">{{ day.date.getDate() }}</span>
          </div>
          <div class="d-flex flex-column gap-2 p-3 w-100 overflow-auto">
            <ng-container *ngFor="let event of eventIndex?.at(day.date.getMonth())?.at(day.date.getDate())">
              <ng-container *ngIf="event">
                <div (click)="eventClick.emit({ date: day.date, event: $event, events: eventIndex?.at(day.date.getMonth())?.at(day.date.getDate()), calendar: this,  context: event })">
                <ng-container [ngTemplateOutlet]="dayTemplate ?? eventTpl" [ngTemplateOutletContext]="{ calendarEvent: event, date: day.date, default:   eventTpl }"></ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #eventTpl let-calendarEvent="calendarEvent" let-date="date" let-customTextTmpl="customTextTmpl">
  <div [class.calendar-month__event--hoverable]="!settings?.disableEventHover" class="shadow w-100 text-white p-2 rounded bg-progreso-blue text-truncate">
    <ng-container [ngTemplateOutlet]="customTextTmpl ?? textTmpl" [ngTemplateOutletContext]="{ calendarEvent: calendarEvent, date: date }"></ng-container>
  </div>
</ng-template>

<ng-template #textTmpl let-calendarEvent="calendarEvent" let-date="date">
  {{ calendarEvent.startDate | date: 'HH:mm' }}
  <i *ngIf="calendarEvent?.faIcon" class="fas fa-fw me-1" [ngClass]="'fa-' + calendarEvent?.faIcon"></i>
  {{ calendarEvent?.label }}
</ng-template>
